import { customPalette } from '../palette'

export const MuiPaper = {
  styleOverrides: {
    root: {
      backgroundColor: customPalette?.background?.overrideDefault,
      borderRadius: 6,
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        color: customPalette?.text?.main,
        '& svg': {
          '& path': {
            fill: customPalette?.text?.main,
          },
        },
        '&:hover': {
          color: 'white',
          '& svg': {
            '& path': {
              fill: 'white',
            },
          },
        },
        fontSize: 12,
        fontWeight: '500',
        '& .MuiSvgIcon-root': {
          fontSize: 18,
        },
      },
    },
  },
}
